<nx-ng-modal-header title="{{ title | i18next }}"></nx-ng-modal-header>
<mat-dialog-content class="mapModal">
  <img
    class="map"
    [src]="imageUrlService.getImageUrl(imageUrl | i18next)"
    alt="{{ imageAltText | i18next }}"
  />
</mat-dialog-content>
